module.exports = __webpack_public_path__ + "img/248623902401250_image.jpg";